module.exports = __webpack_public_path__ + "img/img_filipina.72e07386.svg";